import { Link } from 'react-router-dom';
import { InfoPageLayout } from './InfoPageLayout';

export function DocumentationPage() {
  return (
    <InfoPageLayout title="Documentation" documentTitle="Documentation" metaDescription="Llambada documentation — tutorials and guides for building, improving, and publishing AI-powered mini-apps. Start with the vibe-coding tutorial.">
      <p>
        Welcome to Llambada docs. This page is your starting point for learning
        how to build, improve, and publish mini-apps.
      </p>

      <h2>Guides</h2>

      <h3>How to Vibe-Code an Application With Llambada</h3>
      <p>
        A practical tutorial that walks you through picking an idea, writing
        effective prompts, iterating quickly, and shipping a polished mini-app.
      </p>
      <p>
        <Link to="/docs/how-to-vibe-code-an-application-with-llambada">
          Read the tutorial →
        </Link>
      </p>

      <h3>User Guide</h3>
      <p>
        A broader reference covering key platform features like dashboard
        workflows, publishing, monetization, settings, and troubleshooting.
      </p>
      <p>
        <Link to="/guide">Open the User Guide →</Link>
      </p>

      <h2>Suggested Reading Order</h2>
      <ol>
        <li>
          Start with the vibe-coding tutorial to build your first working
          mini-app quickly.
        </li>
        <li>
          Continue with the user guide for deeper feature coverage and best
          practices.
        </li>
      </ol>

      <h2>Need Help?</h2>
      <p>
        If you get stuck, visit our <Link to="/contact">Contact page</Link> and
        we will help you get unblocked.
      </p>
    </InfoPageLayout>
  );
}
